import { initApplication } from '../components/application';
import { initCartridges } from '../components/cartridges';
import { initCompare } from '../components/compare';
import { initNewsSlider } from '../components/newsSlider';
import { initPower } from '../components/power';

export function initLandingPage() {
  import('../components/landingHero').then(({ initLandingHero }) => {
    initLandingHero();
  });
  initCompare();
  initPower();
  initApplication();
  initCartridges();
  initNewsSlider();

  console.log('📄 Landing page initialized.');
}
